// extracted by mini-css-extract-plugin
module.exports = {"svg":"WheeWave_svg__Syg9F"};